module.exports = __webpack_public_path__ + "0b0939d505d9b16c29acfa90b71631c9.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/opensans-extrabold/opensans-extrabold.woff
// module id = ./src/styles/fonts/opensans-extrabold/opensans-extrabold.woff
// module chunks = index